// extracted by mini-css-extract-plugin
export default {"scroll-to-top":"ScrollToTopButton_scroll-to-top__pgF5o","show":"ScrollToTopButton_show__6s0pe"};